import type { FunctionComponent } from 'react';

import { getDomains } from '@/domains/core/platform/domains/getDomains';
import { getCurrentBaseUrl } from '@/domains/core/platform/getCurrentBaseUrl';
import { routes } from '@/domains/core/routing/routes/routes.default';
import { createURL } from '@/domains/core/routing/URLParser';
import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { useGetProRegisterRoute } from '@/domains/proB2BAnimation/hooks/useGetProRegisterRoute';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import { articlePathToSlugId } from '@/domains/productDiscovery/ProductPage/utils/productUrl/articlePathToSlugId';
import { WelcomeOfferBlock } from '@/productDiscovery/ProductPage/b2c/components/ProBlock/WelcomeOfferBlock';

const trackEvent = () => {
  Gtm.push({
    event: 'interaction_click on login b2b',
    e_category: 'account', // Event category
    e_action: 'login b2b',
    event_trigger: 'Product_page CTA',
    amp_event_name: 'Click on login b2b',
  });
};

export const ProBlock: FunctionComponent = () => {
  const detail = useDetail();
  const { domainPro } = getDomains();

  const b2bProductUrl = `${getCurrentBaseUrl(domainPro)}${createURL(
    routes.product,
    articlePathToSlugId(detail.articlePath),
  )}`;

  const b2bSignupUrl = useGetProRegisterRoute(b2bProductUrl);

  return <WelcomeOfferBlock onClick={trackEvent} url={b2bSignupUrl} />;
};
